module.exports = __webpack_public_path__ + "fonts/icomoon.c0da160.eot";